import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-widgets/dist/css/react-widgets.css';
import { DateTimePicker } from 'react-widgets';
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';


const DateTimeInput = ({
    name,
    label,
    onChange,
    value,
    error
}) => {


    Moment.locale('en-GB')
    momentLocalizer()

    useEffect(() => {
    }, [])

    function handleOnChange(e) {
        var target = { target: { name: name, value: e } };
        onChange(target)
    }

    return (
        <div className="form-group">
            <label htmlFor={name}>{label}</label>
            <div className="field">
                <DateTimePicker format='DD MMM YYYY - LT' onChange={handleOnChange} name={name} value={value} />
                {error && <div className="alert alert-danger">{error}</div>}
            </div>
        </div>
    );
};

DateTimeInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultOption: PropTypes.string,
    value: PropTypes.object,
    error: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object)
};

export default DateTimeInput;



// WEBPACK FOOTER //
// ./src/components/common/formfields/DateTimeInput.js